import { render } from "./WhiteLabelMark.vue?vue&type=template&id=17063314&scoped=true"
import script from "./WhiteLabelMark.vue?vue&type=script&lang=js"
export * from "./WhiteLabelMark.vue?vue&type=script&lang=js"

import "./WhiteLabelMark.vue?vue&type=style&index=0&id=17063314&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17063314"]])

export default __exports__